import React from "react";
import LoginComponent from "../../components/LoginComponent";
import packageJson from "../../../package.json";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { AuthParamList } from "../../types/navigationParams";
import { auth, signInWithEmailAndPassword } from "../../firebase";

type SignInScreenProps = NativeStackScreenProps<AuthParamList, "SignInScreen">;

export default function LoginScreen({ navigation }: SignInScreenProps) {
  return (
    <LoginComponent
      onNavigateForgot={() => navigation.navigate("ForgotPasswordScreen")}
      onNavigateRegister={() => navigation.navigate("RegisterScreen")}
      version={packageJson.version}
      signInFn={async (email: string, password: string) => {
        return signInWithEmailAndPassword(auth, email, password);
      }}
    />
  );
}
